import { AutocompleteInput, maxLength, ReferenceInput, TextInput } from "react-admin";
import { Grid } from "@mui/material";
import { useWatch } from "react-hook-form";
import { administrationRequests } from "api/administrationApi";

// XOR - exactly one of the two fields is sent, so each one disables the other.
const UniversityFields = () => {
  const universityId = useWatch({ name: "universityId" });
  const universityName = useWatch({ name: "universityName" });

  return (
    <>
      <Grid
        item
        xs={12}
        md={6}
      >
        <ReferenceInput
          source="universityId"
          reference={administrationRequests.getUniversitiesSelect()}
        >
          <AutocompleteInput
            label="Университет"
            optionText="name"
            fullWidth
            disabled={Boolean(universityName?.trim())}
            filterToQuery={q => (q?.length > 2 ? { name: q } : {})}
          />
        </ReferenceInput>
      </Grid>
      <Grid
        item
        xs={12}
        md={6}
      >
        <TextInput
          label="Университет (свободен текст)"
          source="universityName"
          fullWidth
          disabled={Boolean(universityId)}
          validate={maxLength(100)}
        />
      </Grid>
    </>
  );
};

export default UniversityFields;
